import { DemandService } from './demandService.js';
import { CaseService } from './caseService.js';

export const DemandUI = {

    currentCaseId: null,
    selectedFacts: new Set(),

    /**
     * Abre el modal de preparación de demanda
     * @param {string} caseId 
     */
    async openDemandModal(caseId) {
        this.currentCaseId = caseId;
        this.selectedFacts.clear();

        // Crear contenedor del modal si no existe
        let modal = document.getElementById('demand-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'demand-modal';
            modal.className = 'modal';
            document.body.appendChild(modal);
        }

        modal.innerHTML = `
            <div class="glass-container" style="width: 90%; max-width: 1200px; height: 90vh; display: flex; flex-direction: column; padding: 0;">
                
                <!-- HEADER -->
                <div style="padding: 1.5rem; border-bottom: 1px solid rgba(255,255,255,0.1); display: flex; justify-content: space-between; align-items: center;">
                    <h2 style="margin:0; color: var(--gold-primary);">⚖️ Preparar Demanda</h2>
                    <button id="close-demand-modal" class="btn-text" style="font-size: 1.2rem;">✖</button>
                </div>

                <!-- BODY -->
                <div style="flex: 1; display: flex; overflow: hidden;">
                    
                    <!-- LEFT: FACT SELECTOR (30%) -->
                    <div style="width: 30%; border-right: 1px solid rgba(255,255,255,0.1); display: flex; flex-direction: column; background: rgba(0,0,0,0.2);">
                        <div style="padding: 1rem; background: rgba(255,255,255,0.05);">
                            <h3 style="margin:0; font-size: 1rem; color: #cbd5e1;">1. Seleccionar Hechos</h3>
                            <p style="font-size: 0.8rem; opacity: 0.7;">Marca los eventos para la demanda</p>
                        </div>
                        <div id="demand-facts-list" style="flex: 1; overflow-y: auto; padding: 1rem;">
                            <!-- Facts injected here -->
                            <div style="text-align: center; padding: 2rem;">Cargando historial...</div>
                        </div>
                    </div>

                    <!-- CENTER: STRATEGY & AI (30%) -->
                    <div style="width: 30%; border-right: 1px solid rgba(255,255,255,0.1); display: flex; flex-direction: column; background: rgba(0,0,0,0.2);">
                         <div style="padding: 1rem; background: rgba(255,255,255,0.05);">
                            <h3 style="margin:0; font-size: 1rem; color: #cbd5e1;">2. Estrategia</h3>
                        </div>
                        <div style="padding: 1rem; flex: 1; overflow-y: auto;">
                            <label class="input-label">Pretensiones (¿Qué pedimos?)</label>
                            <textarea id="demand-pretensiones" class="input-field" rows="4" placeholder="Ej: Pago de daños, nulidad de contrato..."></textarea>
                            
                            <label class="input-label" style="margin-top: 1rem;">Fundamentos de Derecho</label>
                            <textarea id="demand-fundamentos" class="input-field" rows="4" placeholder="Ej: Arts. 1101 C.C., Jurisprudencia X..."></textarea>
                            
                            <label class="input-label" style="margin-top: 1rem;">Pruebas Clave</label>
                            <textarea id="demand-pruebas" class="input-field" rows="4" placeholder="Menciona las pruebas más fuertes..."></textarea>

                            <button id="btn-generate-demand" class="btn-gold" style="width: 100%; margin-top: 1.5rem;">
                                ✨ Redactar con IA
                            </button>
                        </div>
                    </div>

                    <!-- RIGHT: EDITOR (40%) -->
                    <div style="flex: 1; display: flex; flex-direction: column; background: rgba(0,0,0,0.1);">
                        <div style="padding: 1rem; background: rgba(255,255,255,0.05); display: flex; justify-content: space-between;">
                            <h3 style="margin:0; font-size: 1rem; color: #cbd5e1;">3. Borrador Final</h3>
                            <div>
                                <button class="btn-outline" id="btn-save-draft">💾 Guardar</button>
                                <button class="btn-gold" id="btn-export-demand">📄 Exportar PDF</button>
                            </div>
                        </div>
                        <textarea id="demand-editor" style="flex: 1; width: 100%; border: none; background: transparent; color: #e2e8f0; padding: 1.5rem; font-family: 'Times New Roman', serif; font-size: 1.1rem; line-height: 1.6; resize: none; outline: none;" placeholder="El borrador generado aparecerá aquí..."></textarea>
                    </div>

                </div>
            </div>
        `;

        // Event Listeners
        document.getElementById('close-demand-modal').onclick = () => modal.remove();

        document.getElementById('btn-generate-demand').onclick = async () => {
            const btn = document.getElementById('btn-generate-demand');
            const originalText = btn.innerHTML;
            btn.innerHTML = '⏳ Generando...';
            btn.disabled = true;
            try {
                const strategy = {
                    pretensiones: document.getElementById('demand-pretensiones').value,
                    fundamentos: document.getElementById('demand-fundamentos').value,
                    pruebas: document.getElementById('demand-pruebas').value
                };

                // Collect selected facts
                const facts = await this.getSelectedFactsData();

                const draft = await DemandService.generateDemandWithAI(facts, strategy);
                document.getElementById('demand-editor').value = draft;

            } catch (err) {
                console.error("Demand Gen Error:", err);
                if (confirm(`⚠️ Error de IA/Permisos: ${err.message}.\n\n¿Deseas renovar permisos de Google ahora?`)) {
                    try {
                        await AuthService.loginWithGoogle();
                        alert("✅ Permisos actualizados. Intenta de nuevo.");
                    } catch (e) { alert("Error Auth: " + e.message); }
                }
            } finally {
                btn.innerHTML = originalText;
                btn.disabled = false;
            }
        };

        document.getElementById('btn-export-demand').onclick = () => {
            const text = document.getElementById('demand-editor').value;
            if (!text) return alert('No hay contenido para exportar');

            // Dynamic import to avoid load issues if not needed immediately
            import('jspdf').then(({ jsPDF }) => {
                const doc = new jsPDF();

                // Split text to fit page
                const splitText = doc.splitTextToSize(text, 180);

                let y = 20;
                doc.setFont("times", "normal");
                doc.setFontSize(12);

                splitText.forEach(line => {
                    if (y > 280) {
                        doc.addPage();
                        y = 20;
                    }
                    doc.text(line, 15, y);
                    y += 7;
                });

                doc.save(`Borrador_Demanda_${new Date().toISOString().split('T')[0]}.pdf`);
            }).catch(err => console.error("Error loading PDF lib:", err));
        };

        // Load Data
        this.loadFacts(caseId);
    },

    async loadFacts(caseId) {
        const container = document.getElementById('demand-facts-list');
        try {
            // Reutilizamos el servicio de historial o casos para obtener eventos
            // Asumiendo que CaseService tiene un método para obtener todos los eventos o documents
            const actions = await CaseService.getActions(caseId);

            container.innerHTML = actions.length ? '' : '<div style="padding:1rem; text-align:center;">No hay historial disponible</div>';

            actions.forEach(action => {
                const div = document.createElement('div');
                div.className = 'fact-item';
                div.style.padding = '0.8rem';
                div.style.borderBottom = '1px solid rgba(255,255,255,0.05)';
                div.style.display = 'flex';
                div.style.gap = '0.8rem';
                div.style.cursor = 'pointer';
                div.innerHTML = `
                    <input type="checkbox" id="fact-${action.id}" value="${action.id}" style="margin-top: 4px;">
                    <div>
                        <div style="font-weight: bold; font-size: 0.9rem; color: #e2e8f0;">${action.title || action.name || 'Sin título'}</div>
                        <div style="font-size: 0.8rem; color: #94a3b8;">${new Date(action.date?.seconds * 1000 || action.createdTime || Date.now()).toLocaleDateString()}</div>
                        <div style="font-size: 0.85rem; color: #cbd5e1; margin-top: 0.2rem;">${action.description || 'Sin descripción'}</div>
                    </div>
                `;

                // Toggle checkbox on click
                div.onclick = (e) => {
                    if (e.target.type !== 'checkbox') {
                        const cb = div.querySelector('input');
                        cb.checked = !cb.checked;
                    }
                };

                container.appendChild(div);
            });

        } catch (e) {
            console.error("Error loading facts:", e);
            container.innerHTML = '<div style="color:red; padding:1rem;">Error cargando historial</div>';
        }
    },

    async getSelectedFactsData() {
        const checkboxes = document.querySelectorAll('#demand-facts-list input[type="checkbox"]:checked');
        const ids = Array.from(checkboxes).map(cb => cb.value);

        // Need to refetch or store in memory. For now, we'll fetch all and filter (inefficient but safe) or read from DOM
        // Better: store actions in memory when loading.
        // Quick fix: Read from DOM structure or re-fetch.
        // Let's re-fetch for simplicity/safety ensuring up-to-date data, OR usage CaseService cache if available.
        const allActions = await CaseService.getActions(this.currentCaseId);
        return allActions.filter(a => ids.includes(a.id)).map(a => ({
            date: new Date(a.date?.seconds * 1000 || a.createdTime).toLocaleDateString(),
            title: a.title || a.name,
            description: a.description
        }));
    }
};
